import React, { useState } from 'react'
import {Link} from "react-router-dom";
import { toPrice } from '../../reusable';
import { cursorPointer } from '../Home/style';
import Masonry from 'react-masonry-css'
import { useTranslation } from 'react-i18next';
interface Category {
    id: number
    name : string
    value : string
}

interface Image {
    id: number
    title : string
    path : string
    category: Array<string>
}

interface Text {
    fr : string
    en : string
}
interface Room {
    id: number
    title : Text
    description : Text
    guest : number
    size: number
    price: number
    badge: string
    image: string
    images: Array<string>
    category: string
}

function addBadge(badge:string) {
    if(badge!=='' && badge!== null)
    return<div className="knsl-badge">{badge}</div>
}

function renderRoom (item: Room, onClick = function name() {}, text = {guests: 'Guests', night: 'Night', book : 'Book now'}, language = 'en') {
    return(
        <div key={item.id}>
            <div className="knsl-room-card">
            <div className="knsl-cover-frame">
                <Link onClick={onClick} to={`/room?id=${item.id}`}><img src={item.image} alt={`Room ${item.title[language]}, ${item.guest} Guests - The West Heaven Hotel`}/></Link>
                {addBadge(item.badge)}
            </div>
            <div className="knsl-description-frame">
                <div className="knsl-room-features">
                <div className="knsl-feature">
                    <div className="knsl-icon-frame"><img src="assets/img/icons/bed.svg" alt="icon"/></div>
                    <span>{item.guest} {text.guests}</span>
                </div>
                <div className="knsl-feature">
                    <div className="knsl-icon-frame"><img src="assets/img/icons/square.svg" alt="icon"/></div>
                    <span>{item.size} Ft²</span>
                </div>
                </div>
                <Link onClick={onClick} to={`/room?id=${item.id}`}>
                <h3 className="knsl-mb-20">{item.title[language]}</h3>
                </Link>
                <div className="knsl-text-light knsl-text-sm knsl-mb-20">{item.description[language]}</div>
                <div className="knsl-card-bottom">
                <div className="knsl-price">{toPrice(item.price)} xaf<span>/{text.night}</span></div>
                <Link onClick={onClick} to={`/room?id=${item.id}`} className="knsl-btn"><img src="assets/img/icons/bookmark.svg" alt="icon"/>{text.book}</Link>
                </div>
            </div>
            </div>
        </div>
    )
}

function Rooms({items, categories}) {
    const { t, i18n } = useTranslation();

    const [filter, setFilter] = useState({page: 0, key: ''})

    console.log('filter', filter);
    let filteredRooms = items.filter((room:Room) => room.category.includes(filter.key))
    console.log('filtered Rooms', filteredRooms);

    let pages = Math.trunc(filteredRooms.length/20)+1
    let renderRooms = filteredRooms.slice(filter.page*20, (filter.page+1)*20)

    function pageItem(index:number, ) {
        return <li key={index} className={filter.page===index?"knsl-active":""}><a href="#." onClick={() => setFilter({page:index, key: filter.key})}>{index+1}</a></li>
    }

    let pagesList : number[]
    pagesList = []
    for (let i = 0; i < pages; i++) {
        pagesList.push(i)
    }

    return(
        <section className="knsl-p-100-100">
            <img src="assets/img/palm.svg" className="knsl-deco-left" alt="palm"/>
            <div className="container">

                <div className="knsl-filter knsl-mb-60">
                    <span style={cursorPointer} onClick={evt => setFilter({page:0, key: ''})} className={filter.key===''?"knsl-work-category knsl-current":"knsl-work-category"}>{t('main.allRooms')}</span>
                    {categories.map((category: Category) => <span key={category.id} style={cursorPointer} onClick={evt => setFilter({page:0, key: category.value})} className={filter.key===category.value?"knsl-work-category knsl-current":"knsl-work-category"}>{t(`main.${category.name}`)}</span>)}
                </div>
                <Masonry
                    breakpointCols={3}
                    className="knsl-masonry-grid"
                    columnClassName="knsl-masonry-grid-item">
                    {renderRooms.map((item:Room) => renderRoom(item,function onClick(){},{guests: t('main.guests'),night : t('main.night'),book : t('main.bookNow')}, i18n.language))}
                </Masonry>
                <ul className="knsl-pagination">
                    {pagesList.map(index => pageItem(index))}
                </ul>
                
            </div>
            </section>
    )
}

export default Rooms

export {renderRoom}
export type {Room, Image}